// Module
var code = "<template> <div dt-grid-container> <h2>Persondetaljer</h2> <dt-card has-action=\"false\"> <compose model.bind=\"{ personId: personId }\" view-model=\"persons/person-details\"></compose> </dt-card> </div> </template> ";
// Exports
export default code;